if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      // cache within this instance
      this.cards = Array.from(this.querySelectorAll('.shop-the-look__card'));
      this.hotspots = Array.from(this.querySelectorAll('.thb-hotspot'));

      // ensure exactly one active on load
      if (this.cards.length && !this.cards.some(c => c.classList.contains('active'))) {
        this.cards[0].classList.add('active');
      }

      const activateByHandle = (handle) => {
        if (!handle) return;
        const safe = window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/"/g, '\\"');
        const target = this.querySelector(`.shop-the-look__card[data-product-handle="${safe}"]`);
        if (!target) return;
        const current = this.querySelector('.shop-the-look__card.active');
        if (current !== target) {
          if (current) current.classList.remove('active');
          target.classList.add('active');
        }
      };

      // hover + click (click helps touch + accessibility)
      this.hotspots.forEach(hs => {
        const setActive = () => activateByHandle(hs.getAttribute('data-product-handle'));
        hs.addEventListener('mouseenter', setActive);
        hs.addEventListener('click', (e) => { e.preventDefault?.(); setActive(); });
        hs.addEventListener('keypress', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActive(); }
        });
      });
    }
  }
  customElements.define('shop-the-look', ShopTheLook);
}
